/* unplugin-vue-components disabled */import script from "./IntegralTravelSetMeal.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegralTravelSetMeal.vue?vue&type=script&setup=true&lang=js"

import "./IntegralTravelSetMeal.vue?vue&type=style&index=0&id=c99d814a&scoped=true&lang=css"
import "./IntegralTravelSetMeal.vue?vue&type=style&index=1&id=c99d814a&lang=scss"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c99d814a"]])

export default __exports__